import orderBy from 'lodash/orderBy';
import { DateUtils } from '@vectord/utils';

export default function getUpcomingSbatGroups(sbatGroups) {
  return orderBy(
    sbatGroups.filter(
      (sbatGroup) =>
        new Date(sbatGroup.date_of_topic) >= Date.now() - DateUtils.ONE_HOUR
    ),
    (o) => new Date(o.date_of_topic),
    'asc'
  );
}
